import { MapfreInfoDivsComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-info-divs/mapfre-info-divs.component';
import { MapfreLinkComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-link/mapfre-link.component';
import { LiabilitySvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/liability-svg/liability-svg.component';
import { GarageSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/garage-svg/garage-svg.component';
import { DwellingFireSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/dwelling-fire-svg/dwelling-fire-svg.component';
import { PropertySvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/property-svg/property-svg.component';
import { UmbrellaSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/umbrella-svg/umbrella-svg.component';
import { HouseMonoColorSmallSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/house-mono-color-small-svg/house-mono-color-small-svg.component';
import { CarMonoColorSmallSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/car-mono-color-small-svg/car-mono-color-small-svg.component';
import { PolicySvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/policy-svg/policy-svg.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import * as _ from 'underscore';

import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, PolicySvgComponent, CarMonoColorSmallSvgComponent, HouseMonoColorSmallSvgComponent, UmbrellaSvgComponent, PropertySvgComponent, DwellingFireSvgComponent, GarageSvgComponent, LiabilitySvgComponent, MapfreLinkComponent, MapfreInfoDivsComponent],
  selector: 'app-myinsurance-policy-renewal',
  templateUrl: './myinsurance-policy-renewal.component.html',
  styleUrls: ['./myinsurance-policy-renewal.scss'],
})
export class PolicyRenewalComponent implements OnInit,OnChanges {
  @Input() expiringPolicyArray: any;
  policyArrayBetween38And21 = [];
  policyArrayWith21Days = [];
  policyArrayBetween20And0 = [];
  policyWith21DaysStr: any;
  policyBetween20And0Str: any;
  policyFlag = false;
  policy21Flag = false;
  policyList: any;
  loading: boolean;
  livoPolicies: any;
  isAcmic: boolean;
  containLivoPolicy = true;
  constructor(
    private policyDataService: PolicyDataService,
    public router: Router,
    private acmicService: AcmicService,
  ) {
    this.isAcmic = this.acmicService.isACMIC();
  }

  ngOnInit() {
    this.policyDataService.$policyDetails.subscribe((policyResponse: any) => {
      if (policyResponse) {
        this.policyList = policyResponse;
      }
    });
  }

  filter() {
    return _.filter(this.expiringPolicyArray, (policy) => {
      if (
        policy.days_left_to_expire <= 30 &&
        policy.days_left_to_expire > 20 &&
        policy.livoPolicy
      ) {
        this.policyArrayBetween38And21.push(policy.policynumber.policyNumber);
      } else if (
        policy.days_left_to_expire === 21 ||
        (policy.days_left_to_expire === 20 && policy.livoPolicy)
      ) {
        this.policyArrayWith21Days.push(policy.policynumber.policyNumber);
      } else if (
        policy.days_left_to_expire < 21 &&
        policy.days_left_to_expire >= 0 &&
        policy.livoPolicy
      ) {
        this.policyArrayBetween20And0.push(policy.policynumber.policyNumber);
      }
    });
  }

  ngOnChanges() {
    this.livoPolicies = _.pluck(this.expiringPolicyArray, 'livoPolicy');
    this.containLivoPolicy = this.livoPolicies.some((livoPolicy) => {
      return (
        livoPolicy != undefined &&
        livoPolicy != null &&
        livoPolicy &&
        livoPolicy.length > 6
      );
    });

    this.filter();

    if (this.policyArrayBetween20And0.length > 0) {
      this.policyFlag = true;
    }
    if (this.policyArrayWith21Days.length > 0) {
      this.policy21Flag = true;
    }

    this.joinList('policyArrayWith21Days');
    this.joinList('policyArrayBetween20And0');
  }

  joinList(type) {
    if (
      type === 'policyArrayWith21Days' &&
      this.policyArrayWith21Days.length > 0
    ) {
      if (this.policyArrayWith21Days.length === 1) {
        this.policyWith21DaysStr = this.policyArrayWith21Days[0];
      } else {
        const input = this.policyArrayWith21Days;
        const last = input.pop();
        const result = input.join(', ') + ' and ' + last;
        this.policyWith21DaysStr = result;
      }
    } else if (
      type === 'policyArrayBetween20And0' &&
      this.policyArrayBetween20And0.length > 0
    ) {
      if (this.policyArrayBetween20And0.length === 1) {
        this.policyBetween20And0Str = this.policyArrayBetween20And0[0];
      } else {
        const input = this.policyArrayBetween20And0;
        const last = input.pop();
        const result = input.join(', ') + ' and ' + last;
        this.policyBetween20And0Str = result;
      }
    }
  }

  redirectToNewGWPolicy(policyId) {
    this.router.navigate(['/my-insurance', policyId, 'details']);
  }
}
